module.exports = __webpack_public_path__ + "static/allam-c852888c7643a2462176499480165a7e.jpg";